import { Pipe, PipeTransform } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'roles'
})
export class RolesPipe implements PipeTransform {

  constructor(private i18n: TranslateService) {}

  transform(roles: string[], separator?: string): Observable<string> {
    if (!roles || !roles.length) {
      return of('');
    }
    separator = separator || ',';
    return forkJoin(roles.map(role => this.i18n.get(role) as Observable<string>)).pipe(
      map((translations) => translations.join(separator))
    );
  }

}
